const AUTHENTICATED_USER_KEY = `${window.location.hostname}:AUTHENTICATED_USER`;

export default AUTHENTICATED_USER_KEY;
